import Vue from 'vue'
import api from '../../api/api'

const state = {
  all: []
}

// getters
const getters = {}

// actions
const actions = {
  getAllCities ({ commit }) {
    api.getCities(cities => {
      commit('setCities', cities)
    })
  }
}

const mutations = {
  updateCity (state, options) {
    Vue.set(state.all, options.index, options.item)
  },
  setCities (state, cities) {
    state.all = cities
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cities.js